export const checkWarehouse = (type, status, isToFQC) => type === 'assembleDebug' && status === '合格' && !isToFQC;